import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { ROUTES_PATH, UI_CONSTANT } from '../../utility/constants'
import BreadCrumbs from '../breadcrumb/Breadcrumb'
import Button from '../button/Button'
import './StudentPractice.scss'
import correctAnswer from '../../assets/icons/correctAnswer.svg'
import incorrectAnswer from '../../assets/icons/incorrectAnswer.svg'
import { setCurrentQuestionIndex, setAnswer, decrementTime, clearSetAnswer } from '../../store/slice/exam/practiceexam.slice'

function StudentPractice() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const questions = useSelector((state) => state.studentCourse.studentPracticeExamData)
  const currentQuestionIndex = useSelector((state) => state.practice.currentQuestionIndex)
  const selectedAnswers = useSelector((state) => state.practice.selectedAnswers)
  const timeLeft = useSelector((state) => state.practice.timeLeft)

  const breadCrumbsArr = [
    { title: 'Practice', link: null },
    { title: 'Dashboard', link: ROUTES_PATH.STUDENT_DASHBOARD },
    { title: 'Practice', link: ROUTES_PATH.STUDENT_PRACTICE },
    { title: 'US Accounting', link: ROUTES_PATH.STUDENT_PRACTICE },
  ]

  const clearPractice = (dispatch) => {
    dispatch({ type: 'practice/clearExtraReducers' })
  }

  useEffect(() => {
    const timer = setInterval(() => {
      dispatch(decrementTime())
    }, 1000)

    return () => clearInterval(timer)
  }, [dispatch])

  const handleBtnClick = () => {
    clearPractice(dispatch)
    navigate('/dashboard')
  }

  const handleNext = () => {
    if (currentQuestionIndex < questions.length - 1) {
      dispatch(clearSetAnswer())
      dispatch(setCurrentQuestionIndex(currentQuestionIndex + 1))
    }
  }

  const handlePrevious = () => {
    if (currentQuestionIndex > 0) {
      dispatch(setCurrentQuestionIndex(currentQuestionIndex - 1))
    }
  }

  const handleOptionSelect = (option) => {
    const currentQuestion = questions[currentQuestionIndex]
    if (!selectedAnswers[currentQuestion?.course_module_topic_question_set_id]) {
      dispatch(setAnswer({ questionId: currentQuestion?.course_module_topic_question_set_id, answer: option }))
    }
  }

  const formatTime = (timeInSeconds) => {
    const hours = Math.floor(timeInSeconds / 3600)
    const minutes = Math.floor((timeInSeconds % 3600) / 60)
    const seconds = timeInSeconds % 60
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
  }

  const currentQuestion = questions[currentQuestionIndex]
  const selectedOption = selectedAnswers[currentQuestion?.course_module_topic_question_set_id]

  const getButtonClass = (option) => {
    const className = 'option-child'

    if (selectedOption && option === currentQuestion?.answer) {
      return `${className} correct`
    }

    if (selectedOption === option && option !== currentQuestion?.answer) {
      return `${className} incorrect`
    }

    return className
  }

  return (
    <div className='student-practice-exam-main-div'>
      <header className='practice-exam-header'>
        <BreadCrumbs breadCrumbsArr={breadCrumbsArr} />
        <div>
          <p className='practice-exam-timer'>{formatTime(timeLeft)}</p>
        </div>
        <div>
          <Button customClassName='practice-endexam-btn' onClick={handleBtnClick}>
            End Practice
          </Button>
        </div>
      </header>

      <div className='practice-question-div'>
        <div className='practice-question-div-header'>
          <div>
            <p className='us-accounting'>US Accounting</p>

            <div className='que-ans-flex-div'>
              <div className='question'>
                <div className='practiceExam-Que-number-div'>
                  <p>{currentQuestionIndex + 1}</p>
                </div>
                <div className='practiceExam-Que-question-div'>
                  <span>{currentQuestion?.question}</span>
                </div>
              </div>
              <div className='Options-div-parent'>
                {['option1', 'option2', 'option3', 'option4'].map((optionKey, index) => (
                  <div className='option' key={index}>
                    <p>{String.fromCharCode(65 + index)}</p>
                    <button
                      className={getButtonClass(currentQuestion?.[optionKey])}
                      onClick={selectedOption ? null : () => handleOptionSelect(currentQuestion?.[optionKey])}
                    >
                      <span>{currentQuestion?.[optionKey]}</span>
                      {selectedOption && currentQuestion?.[optionKey] === currentQuestion?.answer && (
                        <img src={correctAnswer} alt='Correct' className='answer-image' />
                      )}
                      {selectedOption === currentQuestion?.[optionKey] &&
                        currentQuestion?.[optionKey] !== currentQuestion?.answer && (
                          <img src={incorrectAnswer} alt='Incorrect' className='answer-image' />
                        )}
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <footer className='practice-exam-footer'>
            <p className='practice-exam-footer-currentQuestion'>
              <span>{String(currentQuestionIndex + 1).padStart(2, '0')}</span> /{' '}
              {String(questions?.length).padStart(2, '0')}
            </p>
            <div className='btn'>
              <Button
                customClassName={'btn-Previous'}
                onClick={handlePrevious}
                disabled={currentQuestionIndex === 0 || timeLeft == 0}
              >
                Previous
              </Button>
              <Button
                customClassName={'btn-Next'}
                onClick={handleNext}
                disabled={currentQuestionIndex === questions.length - 1 || timeLeft == 0}
              >
                {UI_CONSTANT.NEXT}
              </Button>
            </div>
          </footer>
        </div>
      </div>
    </div>
  )
}

export default StudentPractice
